import {React} from "react";
import {useSelector} from "react-redux";
import Button from "@mui/material/Button";
import {CircularProgress, TextField, Typography} from "@mui/material";
import EditProfileIcon from "../../../Assets/images/icons/edit";
import {useNavigate} from "react-router-dom";

const EditFormInput = ({label,isEditing, handleInputChange, editedProfile, inputName, inputValue,type,readOnly,icon,showInProfile}) => {
    return (
        <>
            <div style={{
                display : (!showInProfile && !isEditing) ? "none" : "flex"
            }} className={icon ? 'input-row d-flex' : 'input-row d-flex input-row-with-icon'}>
                {
                    icon ?
                        <div className={'icon-label'}>
                            <img src={icon}  />
                        </div>
                         :
                        <Typography className={'input-label'}>
                            {label}
                        </Typography>
                }

                {
                    isEditing ?
                        <TextField
                            value={inputValue || ""}
                            onChange={(e) => handleInputChange(inputName, e.target.value)}
                            size="small"
                            type={type}
                            variant="standard"
                            fullWidth
                            multiline
                            className={'edit-input'}
                            InputProps={{
                                disableUnderline: true,
                                readOnly:readOnly
                            }}
                        /> :
                        <Typography className={'input-label'}>
                            {inputValue}
                        </Typography>
                }

            </div>
        </>
    );
};

export default EditFormInput;
